import React, { useMemo, useCallback, createContext, useContext } from 'react';
import { createMuiTheme, ThemeProvider as MatThemeProvider } from "@material-ui/core/styles";
import { orange, blue, lightBlue, green, lightGreen, yellow, grey, teal } from "@material-ui/core/colors";

export const ThemeContext = createContext();


export const ThemeContextProvider = ({ children }) => {

  const getMaterialPrimaryTheme = useCallback((style) => {
    let primaryColor;
    switch (style.toLowerCase()) {
    case "orange":
      primaryColor = orange;
      break;
    case "lightblue":
      primaryColor = lightBlue;
      break;
    case "blue":
      primaryColor = blue;
      break;
    case "green":
      primaryColor = green;
      break;
    case "lightgreen":
      primaryColor = lightGreen;
      break;
    case "yellow":
      primaryColor = yellow;
      break;
    case "grey":
      primaryColor = grey;
      break;
    case "teal":
      primaryColor = teal;
      break;
    default:
      primaryColor = orange;
      break;
    }

    return createMuiTheme({
      palette: {
        primary: primaryColor
      }
    });
  }, []);

  const rucmonkeyTheme = window.rucmonkeyGlobalConfigs?.styles;
  const materialPrimary = getMaterialPrimaryTheme(window.rucmonkeyGlobalConfigs?.styles.primaryColor ?? "");

  const memoedValue = useMemo(() => {
    return {
      rucmonkeyTheme,
      materialPrimary
    };
  }, [materialPrimary, rucmonkeyTheme]);

  return (
    <ThemeContext.Provider value={memoedValue}>
      <MatThemeProvider theme={materialPrimary}>
        {children}
      </MatThemeProvider>
    </ThemeContext.Provider>
  );
};

export function useTheme() {
  return useContext(ThemeContext);
}